module.exports = __webpack_public_path__ + "images/_/javascripts/components/modal/guidance_slider_modal/images/third_6e67b5f7d72508426c94b7560b860d27.png";